"use client";

import { c as _c } from "react/compiler-runtime";
import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { fingerprintAtom } from "./atom";
function Fingerprint() {
  const $ = _c(4);
  const [fingerprint, setFingerprint] = useAtom(fingerprintAtom);
  let t0;
  let t1;
  if ($[0] !== fingerprint || $[1] !== setFingerprint) {
    t0 = () => {
      if (fingerprint) {
        return;
      }
      getFingerprint().then(result => {
        setFingerprint(result);
      }).catch(_temp);
    };
    t1 = [fingerprint, setFingerprint];
    $[0] = fingerprint;
    $[1] = setFingerprint;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function _temp(error) {
  console.error("Error getting fingerprint:", error);
}
export default Fingerprint;